const initialState = window.init_data;
const initList = (initialState && initialState[3] && initialState[3].list) || [];
export default function featuredNews(state = initList, action) {
  return state || [];
}